import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + '/' + 'api/leadEntity';

  url1 = environment.serverAPI9 + '/' + 'api/leadEntity/exceltemplate';

  url2 = environment.serverAPI4 + "/api/lead";


  addlead(leadEntity): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, leadEntity);
  }

  getLeadById(entityId: number): Observable<Object> {
    return this.http.get(`${this.url}/db/${entityId}`);
  }

  downloadLeadReport(id: any): Observable<any> {
    return this.http.get(`${this.url1}/export/${id}`, { responseType: 'arraybuffer', observe: 'response' });
  }


  getAllLeadDetailsByEntityId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/solr/${leadId}`);
  }

  editLead(leadEntity, leadId: number): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/edit/${leadId}`, leadEntity);
  }

  excelImportLead(data: FormData, id: any): Observable<Object> {
    return this.http.post(`${this.url1}/upload/${id}`, data);
  }

  leadAlreadyExist(payload): Observable<any> {
    return this.http.post(`${this.url}/check/exist`, payload);
  }

  getAllLeadsByEntityId(companyId: any, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url2}/linked/company/${companyId}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getNotificationStatus(notificationId: any): Observable<any> {
    return this.http.get(`${environment.serverAPI4}/api/adminNotification/${notificationId}`);
  }

  getLinkedLeadByDealId(dealId: any): Observable<any> {
    return this.http.get(`${this.url}/deal/linked/lead/${dealId}`);
  }

  getActiveRetry(leadId: number): Observable<any> {
    return this.http.get(`${environment.serverAPI4}/api/leadRetries/${leadId}/active`);
  }

  getRetrySteps(leadId: number, leadRetryId: number): Observable<any> {
    return this.http.get(`${environment.serverAPI4}/api/leadRetries/${leadId}/${leadRetryId}/steps`);
  }

  searchLeadRetries(query: string, page: number, size: number, sort: string, additionalQuery?: string): Observable<any> {
    const requestBody: any = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    if (additionalQuery) {
      requestBody["additionalQuery"] = additionalQuery;
    }
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;
    return this.http.post<any>(`${environment.serverAPI4}/api/leadRetries/condition${queryParams}`, requestBody);
  }

}
